let _canvas;
let _directionsService;
let _directionsRenderer;

function _getDirection(origin, destination) {
  return new Promise((resolve, reject) => {
    _directionsService.route({
      origin: origin,
      destination: destination,
      travelMode: google.maps.TravelMode.DRIVING
    }, (result, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        resolve(result)
      } else {
        reject()
      }
    });
  });
}

function _printTimeStamp(item) {
  return `${item.stringFullDate} ${item.stringHour}:${item.stringMinute}`;
}

class MaverickDirection {
  constructor(config) {
    _directionsService = new google.maps.DirectionsService();
    _directionsRenderer = new google.maps.DirectionsRenderer({
      preserveViewport: true
    });
    _canvas = new google.maps.Map(
      document.getElementById(config.mapId), {
        center: {
          lat: 0,
          lng: 0
        },
        zoom: 9,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      }
    );
    _directionsRenderer.setMap(_canvas);
  }

  async display(locations) {
    const infoWindow = new google.maps.InfoWindow();
    const bounds = new google.maps.LatLngBounds();
    const path = new google.maps.MVCArray();
    const polyline = new google.maps.Polyline({
      map: _canvas,
      strokeColor: '#4986E7'
    });

    for (let index = 0; index < locations.length; index++) {
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[index].point.latitude, locations[index].point.longitude),
        map: _canvas,
        // title: _printTimeStamp(locations[index].timeStamp),
        label: `${index + 1}`
      });

      bounds.extend(marker.position);
      (function (marker, location) {
        google.maps.event.addListener(marker, "click", _ => {
          infoWindow.setContent(_printTimeStamp(location.timeStamp));
          infoWindow.open(_canvas, marker);
        });
      })(marker, locations[index]);

      //   if ((index + 1) < locations.length) {
      //     polyline.setPath(path);
      //     const directionResult = await _getDirection(
      //       new google.maps.LatLng(locations[index].point.latitude, locations[index].point.longitude),
      //       new google.maps.LatLng(locations[index + 1].point.latitude, locations[index + 1].point.longitude));
      //     for (let pathIndex = 0, len = directionResult.routes[0].overview_path.length; pathIndex < len; pathIndex++) {
      //       path.push(directionResult.routes[0].overview_path[pathIndex]);
      //     }
      //   }
    }

    _canvas.setCenter(bounds.getCenter());
    _canvas.fitBounds(bounds);
    _canvas.setZoom(11);
  }
}

export default MaverickDirection;



// WEBPACK FOOTER //
// ./src/plugins/google/direction.js